/**
 * useIsNarrow — true when the viewport is at or below `maxWidthPx`.
 *
 * Used by the Resources surface (Rails Phase 2) to host the registry in the
 * Rail on wide screens and fall back to the in-page two-column layout below
 * the shared --rail-breakpoint (960px), where a 56px Rail can't render the
 * registry. matchMedia-based; SSR/no-matchMedia safe.
 */
import { useEffect, useState } from 'react';

export function useIsNarrow(maxWidthPx: number): boolean {
  const query = `(max-width: ${maxWidthPx}px)`;
  const [matches, setMatches] = useState<boolean>(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

export default useIsNarrow;
